import { SocialIcon } from "react-social-icons";
import { NavLink } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer-main">
      {/* 🔝 TOP SECTION */}
      <div className="footer-top container">
        {/* BRAND */}
        <div className="footer-brand">
          <NavLink to="/" className="navbar-brand brand-logo">
            Bookrr
          </NavLink>
          <p>
            Your one-stop destination for books that inspire, educate &
            entertain.
          </p>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-links">
          <h5>Quick Links</h5>
          <NavLink to="/">Home</NavLink>
          <NavLink to="/shop">Shop</NavLink>
          <NavLink to="/categories">Categories</NavLink>
          <NavLink to="/contact">Contact</NavLink>
        </div>

        {/* SOCIAL */}
        <div className="footer-social">
          <h5>Connect with us</h5>
          <div className="social-icons">
            <SocialIcon url="https://twitter.com/ransherraj1" />
            <SocialIcon url="https://www.facebook.com/profile.php?id=100017568393148" />
            <SocialIcon url="https://www.instagram.com/ransherraj/" />
            <SocialIcon url="https://www.linkedin.com/in/ransherraj/" />
            <SocialIcon url="https://github.com/ransherraj" />
          </div>
        </div>
      </div>

      {/* 🔻 BOTTOM */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} Bookrr. All rights reserved.
      </div>
    </footer>
  );
}
